<template>
  <div>
    <!-- filtros para obtener datos -->
    <filtros
      :plan-filter.sync="localPlan"
      :periodo-filter.sync="localPeriodo"
      :loader="isbusy"
    />

    <!-- Card academico -->
    <resumen-academico
      v-if="datosCrudos"
      :datos="datosCrudos.academico"
      :loader="isbusy"
    />

    <!-- Card economico -->
    <economico
      v-if="datosCrudos"
      :datos="datosCrudos.economico"
      :loader="isbusy"
    />

    <!-- Card Aportaciones -->
    <aportaciones
      v-if="datosCrudos"
      :datos="datosCrudos.transacciones"
      :loader="isbusy"
    />
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { notify } from '@core/utils/notify'
import filtros from './Filtros.vue'
import ResumenAcademico from './ResumenAcademico.vue'
import Economico from './Economico.vue'
import Aportaciones from './Aportaciones.vue'

const { getAnalytics } = require('./Requests')

export default {
  components: {
    filtros,
    ResumenAcademico,
    Economico,
    Aportaciones,
  },
  setup() {
    const datosCrudos = ref(null)
    const localPlan = ref(null)
    const localPeriodo = ref(null)
    const isbusy = ref(false)

    const getActivity = async () => {
      if (!localPlan.value || !localPeriodo.value) return
      isbusy.value = true
      try {
        const resp = await getAnalytics(
          localPlan.value,
          localPeriodo.value,
        )
        datosCrudos.value = resp.data
      } catch (error) {
        notify.error(error)
      } finally {
        isbusy.value = false
      }
    }

    // buscar informacion cuando tengamos periodo definido
    watch([localPlan, localPeriodo], () => {
      if (localPlan.value && localPeriodo.value) {
        getActivity()
      }
    })

    return {
      datosCrudos,
      localPlan,
      localPeriodo,
      isbusy,
    }
  },
}
</script>
